const BASE_URL = process.env.REACT_APP_APPS_SCRIPT_URL;

async function request(body) {
  const res = await fetch(BASE_URL, {
    method: 'POST',
    redirect: 'follow',
    body: JSON.stringify(body),
  });
  if (!res.ok) throw new Error(`API error ${res.status}`);
  return res.json();
}

export const getSalesReport = (params) => request({ action: 'getSalesReport', ...params });
export const getProductionReport = (params) => request({ action: 'getProductionReport', ...params });
